import React, { Component } from 'react';
import _validator from 'modules/validator';
import { Spin } from 'antd';
import _notification from 'modules/notification';
// import "antd/dist/antd.css";
import CandidatePersonalInfo from './CandidatePersonalInfo_new';
import CandidateQualificationInfo from './CandidateQualificationInfo_new';
import CandidateImageSignature from './CandidateImageSignature_new';
import CandidateReservationDetails from './CandidateReservationDetails_new';
// Phase C.7.3 (§13/§14): NavigationTab_new_one is no longer rendered from this dashboard call site —
// its identity fields (Name/Form Number/Applied For/DOB/Mobile Number) are now consolidated into
// HomePageSummary_new.jsx's own single Candidate Identity + Status card (no duplicate information,
// per §14). NavigationTab_new_one.jsx itself is untouched: every wizard sub-page (CandidatePersonalInfo_new.jsx
// etc.) has its own separate, independent `<NavigationTab currentStep={N}/>` render call and is
// completely unaffected by this change — confirmed via a full-repo import search before removing
// this one call site.
//import HomePageSummary from './HomePageSummary';
import HomePageSummary from './HomePageSummary_new';
import _StudentService from '../../modules/StudentService';
import CandidateChallanDetails from './CandidateChallanDetails_new';
import CandidateReceiptDetails from './CandidateReceiptDetails_new';
import SubmitForm from './SubmitForm_new';
import ExamCard from './ExamCard2_new';
import ResultCard from './ResultCard_new';
import InterviewCallLetter from './InterviewCallLetter';
import PreviewCandidateDetails from './PreviewCandidateDetails_new';
// Phase C.9 (Answer Key & Lightweight Online Objection Workflow).
import AnswerKey from './AnswerKey';
// Phase B (Interview Scheduling).
import InterviewSchedule from './InterviewSchedule';

class CandidateRegistration extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef()
    this.state = {
      tabID: -1, //-1,
      data: [],
      progressData:{},
      loading: false
    };
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  componentDidMount() {
    this.getStudentPersonalData();
    if(this && this.props && this.props.location && this.props.location.state && this.props.location.state.tabID !== ""){
      this.setState({
        tabID:this.props.location.state.tabID
      })
      window.history.replaceState({}, '')
    }
  }

  getStudentPersonalData = async () => {
    try {
      this.setState({ loading: true }, async () => {
        try {
          let response = await _StudentService.getStudentPersonalInfo();
          //console.log("Student Data: ", response.data);

          let progress = await _StudentService.getStudentProcessStatus();
          //console.log("StudentProcessStatus Data: ", progress.data.Obj);


          this.setState({ data: response.data, progressData: progress.data.Obj, loading: false });

        } catch (e) {
          // TODO
          this.setState({ loading: false });
          console.log('Error: ', e);
        }
      });
    } catch (e) { }
  }

  onTabOrderChange = (selectedTabID) => {
    this.setState({ tabID: selectedTabID });
    //console.log("Tab Order: ", selectedTabID);
  }

  render() {
    if (this.state.loading)
      return <Spin size="large" />

    return (
      <div className="candidate-home analysisWrap pb-4 ">
        {this.state.tabID == -1 && <HomePageSummary onTabOrderChange={this.onTabOrderChange} data={this.state.data} />}
        {this.state.tabID == 0 && <CandidatePersonalInfo onTabOrderChange={this.onTabOrderChange} />}
        {this.state.tabID == 1 && <CandidateQualificationInfo onTabOrderChange={this.onTabOrderChange} data={this.state.data}/>}
        {this.state.tabID == 2 && <CandidateReservationDetails onTabOrderChange={this.onTabOrderChange} data={this.state.data}/>}
        {this.state.tabID == 3 && <CandidateImageSignature onTabOrderChange={this.onTabOrderChange} IsExamPaymentOnline={this.state.progressData.IsExamPaymentOnline}/>}
        {this.state.tabID == 4 && <CandidateChallanDetails onTabOrderChange={this.onTabOrderChange} IsExamPaymentOnline={this.state.progressData.IsExamPaymentOnline}/>}
        {this.state.tabID == 5 && <SubmitForm onTabOrderChange={this.onTabOrderChange} IsExamPaymentOnline={this.state.progressData.IsExamPaymentOnline}/>}
        {this.state.tabID == 6 && <CandidateReceiptDetails onTabOrderChange={this.onTabOrderChange} />}
        {this.state.tabID == 7 && <ExamCard onTabOrderChange={this.onTabOrderChange} />}
        {this.state.tabID == 8 && <ResultCard onTabOrderChange={this.onTabOrderChange} data={this.state.data} />}
        {this.state.tabID == 9 && <InterviewCallLetter onTabOrderChange={this.onTabOrderChange} data={this.state.data} />}

        {this.state.tabID === 10 && <PreviewCandidateDetails
          onTabOrderChange={this.onTabOrderChange}
          data={this.state.data}
          IsExamPaymentOnline={this.state.progressData.IsExamPaymentOnline}
        />}
        {this.state.tabID === 11 && <AnswerKey onTabOrderChange={this.onTabOrderChange} />}
        {this.state.tabID === 12 && <InterviewSchedule onTabOrderChange={this.onTabOrderChange} />}
      </div>
    );

  }
}

export default CandidateRegistration;
